import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';

import { SearchBar } from '../components';

import { logo } from '../utils/constants';

export default function Navbar() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      p={2}
      sx={{
        position: 'sticky',
        top: 0,
        justifyContent: 'space-between',
        background: '#000',
      }}
    >
      <Link to="/feed" style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="logo" height={45} />
      </Link>
      <SearchBar />
    </Stack>
  );
}
